import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { login, logout, setToken } from "@/store/login/Actions";
import { dispatchThunk } from "@/store/dispatchThunk";
import store from "@/store/store";
import { getAccessToken } from "@/tokens";
import { simpleAlert } from "./pages/modules/alerts";

var UserSession =
/** @class */
function (_super) {
  __extends(UserSession, _super);

  function UserSession(props) {
    var _this = _super.call(this, props) || this;

    _this.getOwnState = function () {
      var s = store.getState();
      return {
        myself: s.imSession.myself,
        token: s.loginSession.token,
        username: s.loginSession.loginUserName || "15262791167",
        password: s.loginSession.loginPassword || "yuanjian"
      };
    };

    _this.onStoreChange = function () {
      _this.setState(_this.getOwnState());
    };

    _this.handleLogin = function (username, password) {
      dispatchThunk(store, login(username, password));
    };

    _this.handleLogout = function () {
      store.dispatch(logout());
    };

    _this.onLogin = function (e) {
      e.preventDefault();

      _this.handleLogin(_this.state.username, _this.state.password);
    };

    _this.onLogout = function (e) {
      e.preventDefault();

      _this.handleLogout();
    };

    _this.state = _this.getOwnState();
    return _this;
  }

  UserSession.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, Promise, function () {
      var token2, action, err_1, error;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.unsubscribe = store.subscribe(this.onStoreChange);
            if (!this.state.token) return [3
            /*break*/
            , 4];
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , getAccessToken(this.state.username, this.state.password)];

          case 2:
            token2 = _a.sent();
            action = setToken(this.state.username, this.state.password, token2);
            store.dispatch(action);
            return [3
            /*break*/
            , 4];

          case 3:
            err_1 = _a.sent();
            error = err_1;
            simpleAlert("Log in failed: " + error.message);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  UserSession.prototype.componentWillUnmount = function () {
    this.unsubscribe && this.unsubscribe();
  };

  UserSession.prototype.render = function () {
    var _this = this;

    var _a, _b;

    var style = {
      position: "fixed",
      top: 0,
      right: 0
    };

    var avatar = this.state.myself && _jsx("img", {
      style: {
        width: 30,
        height: 30
      },
      src: this.state.myself.avatarUrl
    }, void 0);

    if (this.state.token) {
      return _jsxs("div", __assign({
        style: style
      }, {
        children: [_jsx("span", {
          children: "You are currently logged in as user:"
        }, void 0), _jsxs("strong", {
          children: [" ", this.state.username, " "]
        }, void 0), _jsxs("strong", {
          children: [" mySelf: ", ((_a = this.state.myself) === null || _a === void 0 ? void 0 : _a.userId) || ((_b = this.state.myself) === null || _b === void 0 ? void 0 : _b.clientId), " "]
        }, void 0), _jsx("button", __assign({
          onClick: this.onLogout
        }, {
          children: "Logout"
        }), void 0), avatar]
      }), void 0);
    }

    return _jsxs("form", __assign({
      style: style
    }, {
      children: [_jsx("input", {
        type: "text",
        value: this.state.username,
        placeholder: "User Name",
        onChange: function onChange(e) {
          return _this.setState({
            username: e.target.value
          });
        }
      }, void 0), _jsx("input", {
        type: "password",
        value: this.state.password,
        placeholder: "Password",
        onChange: function onChange(e) {
          return _this.setState({
            password: e.target.value
          });
        }
      }, void 0), _jsx("button", __assign({
        onClick: this.onLogin
      }, {
        children: "Login"
      }), void 0), avatar]
    }), void 0);
  };

  return UserSession;
}(Component);

export default UserSession;